export default __webpack_public_path__ + "static/media/Table.0debb005.svg";